import { createAction } from 'redux-actions';

import { CreateExchangeParams, ExchangeOrderFragment } from '@websky/graphql';

interface ActionCallbacksPayload {
	onSuccess?: (exchangeOrder: ExchangeOrderFragment) => void;
}

export type CreateExchangePayload = ActionCallbacksPayload & {
	createExchangeParams?: Partial<CreateExchangeParams>;
	isAutoCreate?: boolean;
};

export type RefuseExchangePayload = ActionCallbacksPayload;

export const CREATE_EXCHANGE_ORDER = 'EXCHANGE/CREATE_EXCHANGE_ORDER';

export const createExchangeOrder = createAction<CreateExchangePayload>(CREATE_EXCHANGE_ORDER);

export const REFUSE_EXCHANGE_ORDER = 'EXCHANGE/REFUSE_EXCHANGE_ORDER';

export const refuseExchangeOrder = createAction<RefuseExchangePayload>(REFUSE_EXCHANGE_ORDER);
